export {};

NLMK.universalTabs = universalTabs;
NLMK.setActiveTab = setActiveTab;

$(universalTabs);

function universalTabs() {
    $(document).on('click', '[data-tabclass]', function onClick() {
        const $this = $(this);
        const content = $this.data('tabclass');
        const number = $this.data('tabnumber');

        $('[data-tabclass="' + content + '"]').each(function each() {
            const $element = $(this);

            if ($element.data('tabnumber') === number) {
                $element
                    .addClass('active')
                    .siblings()
                    .removeClass('active');
            }
        });

        $('.' + content + ' > [data-tabnumber="' + number + '"]')
            .css({ height: 'auto', visibility: 'visible', overflow: 'visible' })
            .addClass('active animated')
            .siblings()
            .css({ height: '0', visibility: 'hidden', overflow: 'hidden' })
            .removeClass('active animated');
    });
}

// api for tabs
function setActiveTab(containerId, activeIndex) {
    const $tabContent = $(`#${containerId}`);
    const $tabItems = $tabContent.find('[data-tabnumber]');
    const $tabBtnContainer = $(`[data-tabs-selector='#${containerId}']`);
    const $tabBtns = $tabBtnContainer.find('[data-tabnumber]');

    // set active tab btn
    $tabBtns.each(function(idx, item) {
        const $item = $(item);
        const tabIdx = $item.data('tabnumber');
        $item.removeClass('active');

        if (+tabIdx === activeIndex) {
            $item.addClass('active');
        }
    });

    // set active tab content
    $tabItems.each(function(idx, item) {
        const $item = $(item);
        const tabIdx = $item.data('tabnumber');
        $item.css({ height: '0', visibility: 'hidden', overflow: 'hidden' }).removeClass('active animated');

        if (+tabIdx === activeIndex) {
            $item.css({ height: 'auto', visibility: 'visible', overflow: 'visible' }).addClass('active animated');
        }
    });
}



// WEBPACK FOOTER //
// ./js/main/module/universal-tabs.js